/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminContextEngineChatBody } from '../models/AdminContextEngineChatBody';
import type { AdminContextEngineChatTaskResponse } from '../models/AdminContextEngineChatTaskResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminContextEngineService {

    /**
     * Admin Context Engine Chat
     * @param requestBody
     * @returns AdminContextEngineChatTaskResponse Successful Response
     * @throws ApiError
     */
    public static adminContextEngineChatApiV1AdminContextEngineChatPost(
        requestBody: AdminContextEngineChatBody,
    ): CancelablePromise<AdminContextEngineChatTaskResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/context-engine/chat',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Admin Context Engine Chat Status
     * @param taskId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static adminContextEngineChatStatusApiV1AdminContextEngineChatTaskIdGet(
        taskId: string,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/context-engine/chat/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Admin Context Engine Chat Direct
     * Call Context Engine inline (no Celery) for low-latency benchmarking.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static adminContextEngineChatDirectApiV1AdminContextEngineChatDirectPost(
        requestBody: AdminContextEngineChatBody,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/context-engine/chat/direct',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
